import { integer, maxLength, minLength, minValue, numeric, required, requiredIf, url } from 'vuelidate/lib/validators'

import { requireIfNotMultiCurrency, sumEqual, vattenfallUrl } from '@/validators/customValidators'

export const contractModel = {
  form: {
    employer: {
      required
    },
    contractor: {
      required
    },
    project: {
      required
    },
    package: {
      required
    },
    contractType: {
      required
    },
    contractManager: {
      required
    },
    packageManager: {
      required
    },
    projectController: { },
    parts: {
      required,
      minLength: minLength(1),
      sumEqual: sumEqual(100, 'ratio', 'isMultiCurrency'),
      $each: {
        name: { required },
        ratio: { required },
        purchaseOrder: { maxLength: maxLength(64) }
      }
    },
    contractName: {
      required
    },
    signatureDate: {
      required
    },
    commencementDate: { },
    takingOverDate: { },
    completionTime: {
      required
    },
    currencies: {
      required,
      $each: {
        key: { required },
        value: { required }
      }
    },
    liquidatedDamagesCap: {
      valueCents: {
        integer
      }
    },
    signedPriceCents: {
      required: requiredIf(requireIfNotMultiCurrency()),
      minValue: minValue(1),
      numeric
    },
    priceBreakdown: {
      required,
      url,
      vattenfallUrl
    }
  }
}

export const parentContractModel = {
  form: {
    project: {
      required
    },
    contractName: {
      required
    }
  }
}

export const workflowModel = {
  form: {
    name: {
      required,
      maxLength: maxLength(32)
    },
    workflowSteps: {
      $each: {
        name: {
          required,
          maxLength: maxLength(32)
        }
      }
    }
  }
}
